import { render, staticRenderFns } from "./AllVHosts.vue?vue&type=template&id=49bd4953&"
import script from "./AllVHosts.vue?vue&type=script&lang=ts&"
export * from "./AllVHosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports